import React, { useEffect, useState } from "react";
import UpcomingHourlyBookingTable from "../UpcomingHourlyBookingTable/UpcomingHourlyBookingTable";
import { getHourlyBookingsAPI } from "../../../../utils/APIs/hourlyAndEditingBookingsApis";

const LIMIT = 10;

const HourlyBookingsPage = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0); // ✅ use total like MyQuote
  const [loading, setLoading] = useState(false);

  const fetchBookings = async () => {
    try {
      setLoading(true);

      const res = await getHourlyBookingsAPI(page, LIMIT, "upcoming");

      const { data, meta } = res.data;

      setData(data);
      setTotal(meta.total); // ✅ store total items

    } catch (err) {
      console.error("Failed to fetch bookings:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const totalPages = Math.ceil(total / LIMIT);

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 3;
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, page + 2);

    if (end - start < maxVisible - 1) {
      if (start === 1) {
        end = Math.min(totalPages, start + maxVisible - 1);
      } else if (end === totalPages) {
        start = Math.max(1, end - maxVisible + 1);
      }
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <>
      {loading && data.length === 0 ? (
        <p>Loading...</p>
      ) : (
        <UpcomingHourlyBookingTable
          data={data}
          page={page}
          limit={LIMIT}
          refetchData={fetchBookings}
        />
      )}

      {total > LIMIT && (
        <div className="pagination">
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          {getPageNumbers().map((p) => (
            <button
              key={p}
              className={`pagination-btn ${p === page ? "active" : ""}`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}

          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default HourlyBookingsPage;



// import React, { useState } from "react";
// import UpcomingHourlyBookingTable from "../UpcomingHourlyBookingTable/UpcomingHourlyBookingTable";

// const LIMIT = 10;

// const HourlyBookingsPage = () => {
//   const [page, setPage] = useState(1);
// const data = [
//   // ===================== BOOKING 1 (FULL CONFIRMED - MULTI SLOT) =====================
//   {
//     bookingId: "BK001",
//     clientName: "Rahul Shah",
//     eventAddress: "Mumbai, Maharashtra",

//     assignedPhotographer: "Amit Kumar",
//     galleryUpload: true,
//     galleryStatus: "uploaded",
//     bookingStatus: "confirmed",

//     hourlyPackages: [
//       {
//         category: "Standard",
//         hours: "0-3 Hours",
//         eventDate: "2026-04-25",
//         eventTime: "18:00 - 21:00",
//         services: [
//           { name: "Photographer", qty: 2, price: 8000 },
//           { name: "Videographer", qty: 1, price: 5000 },
//         ],
//       },
//       {
//         category: "Standard",
//         hours: "5 Hours",
//         eventDate: "2026-04-25",
//         eventTime: "21:00 - 23:00",
//         services: [
//           { name: "Editing", qty: 2, price: 3000 },
//         ],
//       },
//       {
//         category: "Premium",
//         hours: "8 Hours",
//         eventDate: "2026-04-26",
//         eventTime: "10:00 - 18:00",
//         services: [
//           { name: "Drone Shoot", qty: 1, price: 7000 },
//           { name: "Lighting Setup", qty: 2, price: 6000 },
//         ],
//       },
//     ],
//   },

//   // ===================== BOOKING 2 (PENDING + NO PHOTOGRAPHER) =====================
//   {
//     bookingId: "BK002",
//     clientName: "Amit Patel",
//     eventAddress: "Jaipur, Rajasthan",

//     assignedPhotographer: "",
//     galleryUpload: false,
//     galleryStatus: "not_uploaded",
//     bookingStatus: "pending",

//     hourlyPackages: [
//       {
//         category: "Premium",
//         hours: "5 Hours",
//         eventDate: "2026-04-28",
//         eventTime: "10:00 - 15:00",
//         services: [
//           { name: "Videographer", qty: 1, price: 6000 },
//           { name: "Photographer", qty: 1, price: 6000 },
//         ],
//       },
//     ],
//   },

//   // ===================== BOOKING 3 (PROCESSING GALLERY + MIX STATUS) =====================
//   {
//     bookingId: "BK003",
//     clientName: "Neha Mehta",
//     eventAddress: "Delhi",

//     assignedPhotographer: "Rohit Sharma",
//     galleryUpload: true,
//     galleryStatus: "processing",
//     bookingStatus: "confirmed",

//     hourlyPackages: [
//       {
//         category: "Standard",
//         hours: "0-3 Hours",
//         eventDate: "2026-05-02",
//         eventTime: "16:00 - 18:00",
//         services: [
//           { name: "Photographer", qty: 2, price: 8000 },
//         ],
//       },
//       {
//         category: "Standard",
//         hours: "8 Hours",
//         eventDate: "2026-05-02",
//         eventTime: "18:00 - 02:00",
//         services: [
//           { name: "Videographer", qty: 2, price: 18000 },
//           { name: "Editing", qty: 4, price: 5000 },
//         ],
//       },
//     ],
//   },

//   // ===================== BOOKING 4 (FLOAT / UNASSIGNED - HEAVY PACKAGE) =====================
//   {
//     bookingId: "BK004",
//     clientName: "Karan Desai",
//     eventAddress: "Bangalore",

//     assignedPhotographer: "",
//     galleryUpload: false,
//     galleryStatus: "not_uploaded",
//     bookingStatus: "float",

//     hourlyPackages: [
//       {
//         category: "Standard",
//         hours: "5 Hours",
//         eventDate: "2026-05-10",
//         eventTime: "09:00 - 14:00",
//         services: [
//           { name: "Drone Shoot", qty: 1, price: 5000 },
//         ],
//       },
//       {
//         category: "Standard",
//         hours: "8 Hours",
//         eventDate: "2026-05-10",
//         eventTime: "14:00 - 22:00",
//         services: [
//           { name: "Photographer", qty: 3, price: 18000 },
//           { name: "Editing", qty: 5, price: 6000 },
//         ],
//       },
//     ],
//   },

//   // ===================== BOOKING 5 (CANCELLED CASE) =====================
//   {
//     bookingId: "BK005",
//     clientName: "Sana Khan",
//     eventAddress: "Hyderabad",

//     assignedPhotographer: "Unassigned",
//     galleryUpload: false,
//     galleryStatus: "not_uploaded",
//     bookingStatus: "cancelled",

//     hourlyPackages: [
//       {
//         category: "Premium",
//         hours: "0-3 Hours",
//         eventDate: "2026-05-12",
//         eventTime: "12:00 - 15:00",
//         services: [
//           { name: "Photographer", qty: 1, price: 5000 },
//         ],
//       },
//     ],
//   },

//   // ===================== BOOKING 6 (PARTIAL ASSIGNMENT CASE) =====================
//   {
//     bookingId: "BK006",
//     clientName: "Vikram Joshi",
//     eventAddress: "Pune",

//     assignedPhotographer: "Partially Assigned",
//     galleryUpload: false,
//     galleryStatus: "pending",
//     bookingStatus: "confirmed",

//     hourlyPackages: [
//       {
//         category: "Standard",
//         hours: "0-3 Hours",
//         eventDate: "2026-05-15",
//         eventTime: "10:00 - 13:00",
//         services: [
//           { name: "Photographer", qty: 1, price: 4000 },
//         ],
//       },
//       {
//         category: "Standard",
//         hours: "5 Hours",
//         eventDate: "2026-05-15",
//         eventTime: "13:00 - 18:00",
//         services: [
//           { name: "Videographer", qty: 1, price: 6000 },
//         ],
//       },
//     ],
//   },
// ];

//   // ✅ PAGINATION LOGIC (IMPORTANT FIX)
//   const startIndex = (page - 1) * LIMIT;
//   const paginatedData = data.slice(startIndex, startIndex + LIMIT);

//   const totalPages = Math.ceil(data.length / LIMIT);

//   return (
//     <>
//       <UpcomingHourlyBookingTable
//         data={paginatedData}   // ✅ FIXED HERE
//         page={page}
//         limit={LIMIT}
//       />

//       {data.length > LIMIT && (
//         <div className="pagination">
//           <button
//             disabled={page === 1}
//             onClick={() => setPage((p) => p - 1)}
//           >
//             Prev
//           </button>

//           <span>
//             {page} / {totalPages}
//           </span>

//           <button
//             disabled={page === totalPages}
//             onClick={() => setPage((p) => p + 1)}
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </>
//   );
// };

// export default HourlyBookingsPage;